<template>
  <BasePage>
    <div style="margin: 30px auto;width: 70%;display: flex;flex-direction: column;">
      <div style="padding-bottom: 20px;">
        <el-breadcrumb separator-icon="ArrowRight">
          <el-breadcrumb-item :to="{ path: '/' }">当前位置：通知公告</el-breadcrumb-item>
          <el-breadcrumb-item>正文</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div>
        <div class="newsTale_wrap" style="min-height: 500px">
          <div class="newsTable_item" v-for="item in NewsArr" :key="item" @click="setHtml(item)" style="cursor: pointer">
            <div class="newsTable_item_left">
              <div class="newsTable_item_left_title">{{ item.title }}</div>
              <div class="newsTable_item_left_content">{{ item.description }}</div>
              <div class="newsTable_item_left_bottom">
                发布时间：{{ time(item.publishTime) }}
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex;justify-content: end;">
          <el-pagination v-model:current-page="currentPage" background v-model:page-size="pageSize" :page-sizes="[10, 20, 40]" layout="total, sizes, prev, pager, next, jumper" :total="Total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
    <Footer />
    <!-- <RightNav /> -->
  </BasePage>
</template>

<script>
import { onMounted, ref } from "vue";
import BasePage from "@/components/BasePage/BasePage.vue";
import Footer from "@/components/BasePage/components/Footer/Footer.vue";
import RightNav from "@/components/BasePage/components/RightNav/RightNav.vue";
import { useRouter } from "vue-router";
import { pageFindArticleList } from "@/api/index.js";
export default {
  components: { BasePage, Footer, RightNav },
  setup() {
    const router = useRouter();
    const currentPage = ref(1)
    const pageSize = ref(10)
    const Total = ref(1)
    const NewsArr = ref()
    const News = async () => {
      let res = await pageFindArticleList({ currentPage: currentPage.value, pageSize: pageSize.value, categoryId: '937363631216041984' })
      NewsArr.value = res.rows
      Total.value = res.total
    }
    const handleSizeChange = (val) => {
      pageSize.value = val
      News()
    }
    const handleCurrentChange = (val) => {
      currentPage.value = val
      News()
    }
    const setHtml = (item) => {
      window.open(
        router.resolve({
          path: "/InfoView",
          query: { id: item.id },
        }).href,
        "_blank"
      );
    };
    onMounted(async () => {
      await News()
    })
    return {
      NewsArr,
      News,
      handleSizeChange,
      handleCurrentChange,
      currentPage,
      pageSize,
      Total,
      setHtml
    };
  },
  methods: {
    time(value) {
      if (typeof value !== 'string') {
        return '';
      }
      var timeArr = value.replace(" ", ":").replace(/\:/g, "-").split("-");
      var nian = timeArr[0];
      var yue = timeArr[1];
      var ri = timeArr[2];
      var str = nian + '-' + yue + '-' + ri;
      return str
    }
  }
};
</script>

<style scoped>
.newsTable_item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 10px 0 20px;
  border-bottom: 1px dashed #d5dbdd;
}

.newsTale_wrap {
  margin: 0 auto;
  width: 100%;
}

.newsTable_item_left_title {
  color: #6a6a6a;
  font-size: 16px;
  font-weight: bold;
}

.newsTable_item_left_content {
  color: #666666;
  font-size: 14px;
  margin: 4px 0 0;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.newsTable_item_left_bottom {
  color: #999999;
  margin-top: 7px;
  font-size: 14px;
}

.newsTable_item_rigth img {
  width: 130px;
  height: 125px;
  margin-left: 80px;
}
</style>

